module.exports = __webpack_public_path__ + "img/multimedia-collage.a12f4509.png";